module.exports = __webpack_public_path__ + "static/media/readMeS.b9bff666.png";